import script from "./oAuthProviders.vue?vue&type=script&setup=true&lang=js"
export * from "./oAuthProviders.vue?vue&type=script&setup=true&lang=js"

import "./oAuthProviders.vue?vue&type=style&index=0&id=be27a8a2&lang=css"

const __exports__ = script;

export default __exports__